function stringifyDataTracking(obj: unknown): string {
  // TODO : If additional validation is needed, do it in here
  return JSON.stringify(obj);
}

export default stringifyDataTracking;
